module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa bưu cục",
      "breadcrumbs": [{
        title: 'Quản lý bưu cục',
        route: {
          name: 'post-offices'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "createPostOfficeForm",
    attrs: {
      "model": _vm.localPostOffice,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitPostOffice('createPostOfficeForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên bưu cục",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên bưu cục"
    },
    model: {
      value: (_vm.localPostOffice.name),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "name", $$v)
      },
      expression: "localPostOffice.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số điện thoại",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Số điện thoại"
    },
    model: {
      value: (_vm.localPostOffice.phone),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "phone", $$v)
      },
      expression: "localPostOffice.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mã bưu cục",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mã bưu cục"
    },
    model: {
      value: (_vm.localPostOffice.code),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "code", $$v)
      },
      expression: "localPostOffice.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Thành phố",
      "prop": "city_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn thành phố"
    },
    on: {
      "change": _vm.getDistrict
    },
    model: {
      value: (_vm.localPostOffice.city_id),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "city_id", $$v)
      },
      expression: "localPostOffice.city_id"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Quận huyện",
      "prop": "district_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn quận huyện"
    },
    model: {
      value: (_vm.localPostOffice.district_id),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "district_id", $$v)
      },
      expression: "localPostOffice.district_id"
    }
  }, _vm._l((_vm.districts), function(district) {
    return _c('el-option', {
      key: district.id,
      attrs: {
        "label": district.name,
        "value": district.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Hãng vận chuyển",
      "prop": "carrier_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn hãng vận chuyển"
    },
    model: {
      value: (_vm.localPostOffice.carrier_id),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "carrier_id", $$v)
      },
      expression: "localPostOffice.carrier_id"
    }
  }, _vm._l((_vm.carriers), function(carrier) {
    return _c('el-option', {
      key: carrier.id,
      attrs: {
        "label": carrier.name,
        "value": carrier.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Địa chỉ"
    }
  }, [_c('el-input', {
    attrs: {
      "name": "searchmap",
      "placeholder": "Địa chỉ"
    },
    model: {
      value: (_vm.localPostOffice.address),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "address", $$v)
      },
      expression: "localPostOffice.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    attrs: {
      "id": "map"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Vĩ độ",
      "prop": "lat"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Vĩ độ"
    },
    model: {
      value: (_vm.localPostOffice.lat),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "lat", $$v)
      },
      expression: "localPostOffice.lat"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Kinh độ ",
      "prop": "lng"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Kinh độ "
    },
    model: {
      value: (_vm.localPostOffice.lng),
      callback: function($$v) {
        _vm.$set(_vm.localPostOffice, "lng", $$v)
      },
      expression: "localPostOffice.lng"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5c131bf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/postOffice/EditPostOffice.vue
// module id = 712
// module chunks = 1